module.exports = __webpack_public_path__ + "static/media/team-document.1e64bb8b.md";